import { ServerConfig } from "@/config/config";
import { Terminal } from "@/utils/ctep/terminal";
import { Axios } from "./auth-service";
import { TerminalOwner } from "@/utils/ctep/terminal-owner";

class CtepServiceClass {
	public readonly url:string = `${ServerConfig.mainAppHost}/ctep`;

	public async getTerminalsWithNoOwner():Promise<Terminal[]> {
		let result = await Axios.get(`${this.url}/terminals-with-no-owner`);
		return (result.data || []).map((t:any)=>new Terminal(t));
	}

	public async getTerminalsByCompanyId(companyId:number):Promise<TerminalOwner[]>{
		let result = await Axios.get(`${this.url}/terminals-by-company-id/${companyId}`);
		return (result.data || []).map((t:any)=>new TerminalOwner(t));
	}

	public async registerTerminal(terminalId:string, companyId:number):Promise<void> {
		await Axios.post(`${this.url}/${encodeURIComponent(terminalId)}/register`, {CompanyID: companyId});
	}

	public async setNickname(terminalId:string, nickname:string):Promise<void> {
		await Axios.post(`${this.url}/${encodeURIComponent(terminalId)}/set-nickname`, {Nickname: nickname});
	}

	public async unregisterTerminal(terminalId:string):Promise<void>{
		await Axios.post(`${this.url}/${encodeURIComponent(terminalId)}/unregister`);
	}
}

export const CtepService = new CtepServiceClass();